import { Component, Input } from '@angular/core';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';
import { Destroyer } from 'src/app/core/abstract/destroyer';
import { putToClipboard } from 'src/app/core/utils/dom-utils';

@Component({
  selector: 'craft-copy-text-button',
  templateUrl: './craft-copy-text-button.component.html',
  styleUrls: ['./craft-copy-text-button.component.scss'],
  standalone: false,
})
export class CraftCopyTextButtonComponent extends Destroyer {
  @Input() public text = '';
  @Input() public btnClass = '';
  @Input() public disabled = false;
  @Input() public tooltipPosition: TooltipPosition = 'above';
  @Input() public tooltipStartText = 'Copy';
  @Input() public tooltipCopiedText = 'Copied!';

  public tooltipText = this.tooltipStartText;

  constructor() {
    super();
  }

  public copyText(tooltip: MatTooltip, e?: MouseEvent) {
    if (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }

    putToClipboard(this.text);
    tooltip.show(0);
    this.tooltipText = this.tooltipCopiedText;
  }

  public reset() {
    this.tooltipText = this.tooltipStartText;
  }
}
